import Vue from 'vue';
import {mapMutations, mapGetters, mapState} from 'vuex';

import Count from '@components/ui/count.vue';
import Button from '@components/ui/button.vue';
import Pagination from '@components/ui/pagination.vue';
import MiddleBlock from '@components/products-grid/products/middleBlock/script.js';

let PageComponent = {
    name: 'catalog-id',
    data() {
        return {
            template: '<p>default temp id</p>',
            visibleDropdown: false,
            activeSort: {
                value: 'По умолчанию',
                id: ''
            },
            sortOptions: [
                {
                    value: 'по умолчанию',
                    id: ''
                },
                {
                    value: 'цена по возрастанию',
                    id: 'priceUp'
                },
                {
                    value: 'цена по убыванию',
                    id: 'priceDown'
                }
            ],
        };
    },
    components: {
        't-count': Count,
        't-button': Button,
        'middle-product-block-cmp': MiddleBlock,
        't-pagination': Pagination,
    },
    computed: {
        ...mapState('params', ['mobile']),
    },
    methods: {
        ...mapMutations('cart', ['addItemToCart']),
        ...mapGetters('cart', ['checkInCart']),
        setTemplate: function (template) {
            this.template = template.data;
        },
        setData: function (data) {
            this.setTemplate(data);
        },
        changeSort(id, name) {
            this.closeDropdown();

            if (id) {
                this.activeSort.value = name;
                this.activeSort.id = id;
                this.$router.push({path: this.$route.path, query: {sort: id}}).catch(err => {});
            } else {
                this.activeSort.value = this.sortOptions[0].value;
                this.activeSort.id = this.sortOptions[0].id;
                this.$router.push({path: this.$route.path, query: {}}).catch(err => {});
            }
        },
        closeDropdown() {
            if (!this.mobile) {
                this.visibleDropdown = false;
            }
        },
    },
    created() {
        if (this.$route.query.sort) {
            this.sortOptions.forEach((item) => {
                if (item.id === this.$route.query.sort) {
                    this.activeSort.value = item.value;
                    this.activeSort.id = item.id;
                }
            });
        } else {
            this.activeSort.value = this.sortOptions[0].value;
            this.activeSort.id = this.sortOptions[0].id;
        }
    },
    beforeRouteUpdate(to, from, next) {
        console.log('beforeRouteUpdate _id', to);

        if (to.params.id) {
            let url = '/api/templates/products/' + to.params.id;
            Vue.http.get(url, {params: to.query}).then((data) => {
                this.setData(data);
                next();
            });
        } else {
            next('/404');
        }
    },
    beforeRouteEnter(to, from, next) {
        console.log('beforeRouteEnter _id', to);

        if (window.content) {
            next((vm) => {
                vm.template = window.content;
                window.content = undefined;
            });
        } else if (to.params.id) {
            let url = '/api/templates/products/' + to.params.id;
            Vue.http.get(url, {params: to.query}).then(
                (data) => {
                    next((vm) => vm.setData(data));
                }
            );
        } else {
            next('/404');
        }
    },
    render(createElement) {
        return Vue.compile(this.template).render.call(this, createElement);
    },
};
export default PageComponent;



// WEBPACK FOOTER //
// ./src/templates/pages/products/_id/index.js